import { api, unwrap, repeatedParams } from './http';

export default {
  list: async (params = {}) => unwrap(api.get('/Members', params)),

  getMemberById: async (memberId) => {
    const data = await unwrap(api.get(`/Members/${memberId}`));
    if (data) return data;
    throw new Error('Server returned false or error');
  },

  getProfileChanges: async (memberId) => unwrap(api.get(`/Members/${memberId}/ProfileChanges`)),

  create: async (payload) => unwrap(api.post('/Members', payload)),

  update: async (memberId, payload) => unwrap(api.put(`/Members/${memberId}`, payload)),

  remove: async (memberId) => unwrap(api.delete(`/Members/${memberId}`)),

  bulkDelete: async (ids) => unwrap(api.delete('/Members', repeatedParams('ids', ids))),

  getFinancialStatus: async (memberId, from, to) => {
    const data = await unwrap(api.get('/Members/GetFinancialStatus', {
      MemberId: memberId,
      DateFrom: from || '',
      DateTo: to || '',
    }));
    if (data) return data;
    throw new Error('Server returned status false');
  },

  searchByFullName: async (fullName, extra = {}) => unwrap(api.get('/Members', { FullName: fullName, ...extra })),

  searchByWord: async (word) => unwrap(api.get('/Members/GetMembersBySearchWord', { searchword: word })),

  // Unified email lookup for every profile form (member/admin/professional, create + edit).
  // Returns { exists, userAccountId, fullName, canLogin, existsAtCurrentTenant,
  // currentTenantMemberId, rolesAtCurrentTenant[], existsInOtherTenant, status }. Pass memberId
  // when editing an existing member, or role (the role being added) when creating.
  resolveEmailOwner: async (email, { memberId, role } = {}, config) => unwrap(api.get(
    '/Members/ResolveEmailOwner',
    { email, ...(memberId != null ? { memberId } : {}), ...(role ? { role } : {}) },
    config,
  )),

  // Unified-identity lookup: recognize an existing person by email/phone and prefill the form.
  // Returns UserAccount-level fields only + alreadyMemberAtTenant. 404: IDENTITY_V2_ENABLED is off.
  lookupMember: async ({ email, phone } = {}, config = {}) => unwrap(api.get('/Members/Lookup', { email, phone }, config)),

  // Link an existing person (UserAccount) to this club: creates the Member row and returns its id.
  linkExistingMember: async (userAccountId) => unwrap(api.post('/Members/LinkExisting', { userAccountId })),

  getMemberStatusData: async (memberId) => unwrap(api.get('/Members/GetMemberStatusData', { MemberId: memberId })),

  getRelationTypes: async () => unwrap(api.get('/Members/GetMembersRelationsType')),

  getCountOfActive: async () => unwrap(api.get('/Members/GetCountofActiveMembers')),

  loadActive: async (params = {}) => unwrap(api.get('/Members/Load/Active', params)),

  uploadAvatar: async (memberId, formData, config = {}) => unwrap(api.post(`/Members/${memberId}/avatar`, formData, config)),
};
